<template>
    <div class="p-5 darker">

        <h5>
            Custom Sales Channel
        </h5>

        <div class="my-4">
            Define your custom sales channels so you can choose them when adding new reservations. For each channel you can define default invoice settings.
        </div>

        <div v-if="getSalesChannels.length < 1" class="text-center dark fs-large w-100">
            No sales channels available
        </div>

        <div>
            <div class="col-sm-6">
                <div v-if="getSalesChannels.length > 0" class="d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover" v-for="salesChannel in getSalesChannels">
                    <div class="darker bold">{{salesChannel.name}}</div>
                    <div class="withHover">
                        <span class="lighter bg-dark radius-normal fs-small px-2 pointer" @click="edit(salesChannel)">Edit</span>
                        <i v-if="!salesChannel.isImmutable" class="ico ico-delete fs-normal dark pointer ml-2" @click="clickTrash(salesChannel)"></i>
                    </div>
                </div>
                <button class="btn wide mt-4" @click="AddSalesChannel">Add Sales Channel</button>
            </div>
        </div>

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'
    import List from '@/tools/list/baseList'

    export default {
        data: function() {
            return {
            }
        },
        props:[
            'presets'
        ],
        computed:{
            ...mapGetters([
                'getSalesChannels',
            ])
        },
        methods:{
            ...mapActions([
                'saveSettingsPresets',
                'setSelectedSalesChannel',
                'deleteSalesChannel',
                'openModal'
            ]),
            AddSalesChannel: function() {
                this.openModal('salesChannels/createSalesChannel')
            },
            edit: function(salesChannel) {
                this.setSelectedSalesChannel(salesChannel)
                this.openModal('salesChannels/editSalesChannel')
            },
            clickTrash: function(salesChannel) {
                let vm = this

                this.$dialog.confirm('\
                <div class="fs-larg font-weight-600 mb-4">Delte sales channel?</div>\
                <div>Your are about to delete the sales channel "'+salesChannel.name+'", continue?</span></div>')
                .then(function () {
                    vm.deleteSalesChannel(salesChannel)
                })
                .catch(function () {
                    // pressed No
                });
            }
        },
        components:{
            vSelect: extendedVSelect,
            List
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TabSalesChannels.vue?f71f7514